import React from 'react'

export default function ApplyLoan(data) {
 console.log("application datta",data)
  return (
    <section className="bg_white pt-50 pb-10 ">
    <div className="container">
      <div className="description-widget">
    
          
      
          
            <div className="desc-text pl-lg-10" style={{disalignItems:"center",justifyContent:"center"}}>
            <h3 style={{color:"black"}}>{data?.data?.contentHeading}</h3>

              <p>
              {data?.data?.contentSubHeading}
              </p>
            
        
        </div>
      </div>
    </div>
  </section>
  

  )
}
